import React from 'react'
import dynamic from 'next/dynamic'
import { getMfInstance } from '@/clients/moduleFederation'
import { GlobalElementsPageProps } from '@/types'

export type FooterProps = GlobalElementsPageProps

const REMOTE_MODULE = 'koodoGlobalElementsMfe/Footer'
const NullComponent = () => null

// Dynamically load Footer from MFE on client only using Runtime Federation
const FooterComponent = dynamic<FooterProps>(
  () => {
    const mfInstance = getMfInstance()
    if (!mfInstance) {
      console.warn('[Module Federation] Instance not initialized')
      return Promise.resolve({ default: NullComponent })
    }

    return mfInstance
      .loadRemote<{ default: React.ComponentType<FooterProps> }>(REMOTE_MODULE)
      .then((module) => module ?? { default: NullComponent })
      .catch((error) => {
        console.error('[Module Federation] Failed to load Footer:', error)
        return { default: NullComponent }
      })
  },
  { ssr: false }
)

const Footer: React.FC<FooterProps> = ({ locale, environment }) => (
  <FooterComponent locale={locale} environment={environment} />
)

export default Footer
